module.exports = __webpack_public_path__ + "media/images/area_2-f648c0dc7577f7cfc80793685c4dc0fc.png";